import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
export const AboutContainer=styled(Box)(({theme})=>({
    backgroundColor:"#D7C21B",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "35px 64px",
    scrollMarginTop:"10px",
    [theme.breakpoints.down('md')]:{ 
        padding:"36px 3px"
    }
}));
export const HiText=styled(Typography)(()=>({
    fontWeight: "bold",
    fontSize: "44px",
    color: "#8000a4",
    textWrap: "nowrap",
    whiteSpace:"nowrap"
}));
export const Designation=styled(Typography)(()=>({
    fontWeight: "bolder",
    fontSize: "30px",
    color: "#003e3e",
    textWrap: "nowrap",
    whiteSpace:"nowrap"
}));
export const Description=styled(Typography)(()=>({
    textAlign: "center",
    color: "#8000a4",
    fontSize: "19px",
    fontWeight:700
}));